module.exports = __webpack_public_path__ + "img/energy_alt.94f0166.svg";